//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Options.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["name"],"GetIntValue",{R_:{value:''}},1,0],[["name"],"GetRealValue",{R_:{value:''}},1,0],[["name"],"GetStringValue",{R_:{value:''}},1,0],[["name"],"GetUtf8stringValue",{R_:{utf8_value:''}},1,0],[["name","count"],"GetStringListValue",{R_:{value:""}},1,0],[["name","count","selection"],"GetReorderSelectableStringListValue",{R_:{value:""}},1,0],[["name"],"GetLogicalValue",{R_:{value:''}},1,0],[["name","level"],"GetIntValueAtLevel",{R_:{value:''}},2,0],[["name","level"],"GetRealValueAtLevel",{R_:{value:''}},2,0],[["name","level"],"GetStringValueAtLevel",{R_:{value:''}},2,0],[["name","level"],"GetUtf8stringValueAtLevel",{R_:{value:''}},2,0],[["name","level","count"],"GetStringListValueAtLevel",{R_:{value:""}},2,0],[["name","level","count","selection"],"GetReorderSelectableStringListValueAtLevel",{R_:{value:""}},2,0],[["name","level"],"GetLogicalValueAtLevel",{R_:{value:''}},2,0],[["level","locked_by_default"],"NewOptionsChangeList",{R_:{data:"Options.ChangeList"}},2,0],[["level","filename"],"NewOptionsDraftingStandardChangeList",{R_:{data:"Options.DraftingStandardChangeList"}},2,0],[["count"],"GetAllOptions",{R_:{options:""}},0,0],[["name","level"],"IsValueLocked",{R_:{status:''}},2,0],[["name","level"],"IsValueSet",{R_:{status:''}},2,0],[["name","level"],"GetUserComment",{R_:{comment:''}},2,0],[["name"],"GetOptionType",{R_:{type:''}},1,0],[["level"],"IsLevelLockedByDefault",{R_:{status:''}},1,0],[["name"],"GetScope",{R_:{scopeValue:''}},1,0]],[]];
SPLM.Options.OptionsManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Options.OptionsManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Options.OptionType = Object.freeze({
    "Int" : "Int", "Real" : "Real", "String" : "String", "StringList" : "StringList", "Logical" : "Logical", "Utf8string" : "Utf8string", "Utf8stringList" : "Utf8stringList", "ReorderSelList" : "ReorderSelList"});

SPLM.Options.OptionsScope = Object.freeze({
    "Part" : "Part", "Session" : "Session"});

export default SPLM;